module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "suscripciones"
  }, [_h('div', {
    staticClass: "container"
  }, [_h('div', {
    staticClass: "row"
  }, [_h('h1', ["Listado de Suscripciones"]), " ", _vm._l((_vm.suscripciones), function(suscripcion) {
    return _h('div', [_h('h2', ["Mail: " + _vm._s(suscripcion) + " "])])
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5650dde6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Suscripciones.vue
// module id = 202
// module chunks = 2